<template>
  <div class="PlayerGames container">
    <Loader :url='getGames ()' v-model="games">
      <Table slot="result">
        <Row header>
          <Cell></Cell>
          <Cell>Game Name</Cell>
          <Cell>Average Rating</Cell>
          <Cell>Rating</Cell>
          <Cell>Result</Cell>
          <Cell>Uploaded</Cell>
        </Row>

        <Row
          v-for="summary in games"
          :style="`background-color: ${rgba('--wc3-' + (summary.isWinner ? 'green' : 'red'), 0.05)}`"
          :to="{ name: 'gameProfile', params: { id: summary.gameId }}"
        >
          <Cell class="text-center">
            <Block :colour="summary.colour" class="PlayerGames-block"></Block>
          </Cell>
          <Cell>{{ summary.gameName }}</Cell>

          <Cell>
            {{ summary.avgRating }}

            <Bar width="100px"
                 :fill="relative ('avgRating', summary, games)"></Bar>
          </Cell>

          <Cell>
            {{ summary.rating }}

            <Bar width="100px"
                 :fill="relative ('rating', summary, games)"></Bar>
          </Cell>
          <Cell>
            <Delta
              :x="summary.delta"
              :showNumber="true"
            ></Delta>
          </Cell>
          <Cell>{{ timeago (summary.playedOn) }}</Cell>
        </Row>
      </Table>
    </Loader>
  </div>
</template>

<script>
  import * as moment from 'moment';
  import Loader from '@/legacy/components/widgets/Loader';
  import Delta from '@/legacy/components/widgets/Delta';
  import Block from '@/legacy/components/widgets/Block';
  import Bar from '@/legacy/components/widgets/Bar';
  import { Table, Row, Cell } from '@/legacy/components/widgets/Table.js';
  import { time } from '@/legacy/lib//util';
  import { httpBuildQuery, ordinal, relative, timeago, urlencode } from '@/legacy/lib//util';
  import { rgba, metaFactory } from '@/legacy/lib//template';

  export default {
    metaInfo () {
      return metaFactory ({
        title: `${this.account.name} Games`,
        description: `Browse and search a real-time games directory for every Warcraft III replay ${this.account.name} has ever uploaded.`
      });
    },

    props: {
      account: {
        type: Object
      },

      profile: {
        type: Object
      }
    },

    data: function () {
      return {
        games: []
      }
    },

    components: {
      Loader,
      Table,
      Row,
      Cell,
      Delta,
      Block,
      Bar
    },

    methods: {
      ordinal,
      rgba,
      moment,
      relative,
      timeago,

      getGames () {
        return httpBuildQuery (
          `/profiles/${urlencode (this.account.name)}/games`,
          {
            map: this.profile.map,
            mode: this.profile.modeCode
          }
        );
      }
    }
  };
</script>

<style lang="scss">
</style>